import { Table, Tag, Tooltip, Typography } from 'antd';
import _ from 'lodash';
import moment from 'moment';
import { categoryMap, subCategoryMap } from 'modules/navbar/top/helper';

const columns2 = [
  { title: 'Customer Name', width: 150, dataIndex: 'customer_name', key: 'customer_name', fixed: 'left' },
  { title: 'Ticket Assignment', width: 150, dataIndex: 'current_assignment_name', key: 'current_assignment_name', fixed: 'left' },
  { title: 'Slot Assgned to', width: 150, dataIndex: 'medical_slot_assignment', key: 'medical_slot_assignment', fixed: 'left' },
  { title: 'Orded Id', width: 100, dataIndex: 'order_display_id', key: 'order_display_id' },
  { title: 'Category', dataIndex: 'category', width: 200, key: '2' },
  { title: 'Sub Category', dataIndex: 'sub_category', width: 200, key: '3' },
  { title: 'Status', dataIndex: 'status', width: 100, key: '4' },
  { title: 'Created At', dataIndex: 'ticket_created_at', width: 200, key: '5' },
  { title: 'Due date', dataIndex: 'due_date', width: 200, key: '6' },
  { title: 'Author', dataIndex: 'author', width: 200, key: '7' },
  { title: 'Slot Time', dataIndex: 'slot_time', width: 200, key: '8' },
  { title: 'Doctor Slot Time', dataIndex: 'doctor_slot_time', width: 200, key: '9' },
  { title: 'Call Start Time', dataIndex: 'call_start_time', width: 200, key: '10' },
  { title: 'Call End Time', dataIndex: 'call_end_time', width: 200, key: '11' },
  { title: 'Unanswered Count', dataIndex: 'unanswered_count', width: 200, key: '12' },
  { title: 'Overdue', dataIndex: 'over_due', width: 75, key: '13', fixed: 'right' },
  { title: 'Slot Call Completed', dataIndex: 'slot_call_completed', width: 145, key: '14', fixed: 'right' }
];

const MedicalEscalationTable = ({ tickets, selectedRowKeys, setSelectedRowKeys, medEscResponseLoading, extractCallDetails }) => {

  const tableData = tickets?.map((ticket) => {
    const customer_name = <Tooltip title="Lead Details">
      <Typography.Link href={`/lead-details/${ticket.case_id}`} target="_blank">{_.get(ticket, ['customer', 'first_name'], '')}</Typography.Link>
    </Tooltip>
    const tags = {
      Closed: "red",
      Open: "green",
      Pending: "orange",
      Resolved: '',
    }
    const current_assignment_name = _.get(ticket, ['current_assignment', 'first_name'], '');
    const order_display_id = _.get(ticket, ['source_meta', 'order_display_id'], '-');
    const medical_slot_assignment = _.get(ticket, 'medical_slot_assignment', 'N/A');
    const priority = _.get(ticket, 'priority', '');
    const category = categoryMap[_.get(ticket, 'category', '')];
    const sub_category = _.get(subCategoryMap, ticket.sub_category, ticket.sub_category);
    const ticketStatus = _.get(ticket, 'status', '');
    const status = <Tag color={tags[ticketStatus]}>{ticketStatus}</Tag>
    const ticket_created_at = moment(ticket.createdAt).format('MMMM D, YYYY hh:mm A')
    const dueDate = _.get(ticket, ['provider_meta', 'due_date'], null);
    const due_date = dueDate ? moment(dueDate).format('MMMM D, YYYY hh:mm A') : 'N/A';
    const author = _.get(ticket, ['author', 'first_name'], '');
    const medicalEngagementReminderDate = _.get(ticket, ['medicalEngagements', 0, 'reminder_date'], null);
    const slot_time = medicalEngagementReminderDate ? moment(medicalEngagementReminderDate).format('MMMM D, YYYY hh:mm A') : '-'
    const doctor_slot_time = _.get(ticket, 'doctorSlotTime', 'N/A');
    const callDetails = extractCallDetails(ticket);
    const call_start_time = _.get(callDetails, ['start'], '');
    const call_end_time = _.get(callDetails, ['end'], '');
    const unanswered_count = _.get(ticket, ['medicalEngagements', 0, 'unanswered_count'], '-');
    const over_due = slot_time ? moment(slot_time).isBefore(moment()) ? 'Yes' : 'No' : 'N/A';
    const operationStatus = _.get(ticket, ['medicalEngagements', 0, 'operation_status'], null);
    const medicalStatus = _.get(ticket, ['medicalEngagements', 0, 'status'], null);
    let slot_call_completed ='';

    if (medicalStatus === 'active') {
      if (unanswered_count < 1) {
        slot_call_completed = 'Not Attempted';
      } else {
        slot_call_completed = 'Unanswered';
      }
    } else {
      if (['auto_completed', 'system_completed'].includes(operationStatus)) {
        slot_call_completed = 'Unanswered';
      } else if (!operationStatus || operationStatus === 'completed' ) {
        slot_call_completed = 'Answered';
      }
    }
    return { key: ticket._id, doctor_slot_time, customer_name, current_assignment_name, order_display_id, medical_slot_assignment, priority, category, sub_category, status, ticket_created_at, due_date, author, slot_time, call_start_time, call_end_time, over_due, slot_call_completed }
  });
  const onSelectChange = (newSelectedRowKeys) => setSelectedRowKeys(newSelectedRowKeys);
  return <div>
    <Table
      rowSelection={{ selectedRowKeys, onChange: onSelectChange }}
      pagination={false}
      columns={columns2}
      dataSource={tableData}
      scroll={{ x: 3300 }}
      size="middle"
      loading={medEscResponseLoading}
    />
  </div>

}
export default MedicalEscalationTable